export default {
  main: {
    site_id: 18773850,
    title: 'Terminal PRO',
    enableWorldCup: true,
    showBetBuilderSection: true,
    terminalId: 1,
    enableMultipleTicketPay: true,
    isTicketsCheckable: true,
    needAdminForResetPin: false,
    ticketAvailableViewMode: ['card'],
    enableTicketAutoCashoutAmountUpdate: false,
    enableTicketPopupFlow: true,
    isWithdrawal: true,
    enableKeyboardCatching: true,
    enableThemeToggle: false,
    enableTicketTimer: true,
    restrictedAdminPrintableTicketsCount: 5,
    hasDayFilter: true,
    signInType: 'email',
    staffPassword: '0',
    enableRegistration: true,
    enableHeaderAdminSection: true,
    homeMediaSlides: [
      {
        type: 'boosted',
        path: 'betting/prematch/all/boosted/all/all',
      },
      {
        type: 'sport',
        path: 'betting/prematch/all',
      },
    ],
    websitePasswordHash: '1e4b63ec913a0b02ee8aecfa6c866bcd8269c99e9853af0afa776dab8ecfe9c5',
    logoSize: "extra-huge-with-height",
    termsAndConditions: false,
    showEventTypeFilter: true,
    cashoutCommissionPercent: 4,
    resultPageVirtualsId: [150, 197, 209, 118, 54, 55, 31, 184, 181],
    rfidPinCode: false,
    showTicketAfterPay: 10000,
    popupForTerminalLock: false,
    mandatoryCasinoLogin: false,
    enableClientDepositMode: true,
    useCurrencySymbol: true,
    availableLanguages: {
      '@replace': true,
      fra: {
        short: 'FR',
        name: 'Fra',
        order: 1,
      },
      eng: {
        short: 'EN',
        name: 'Eng',
        order: 2,
      },
    },
  },
  env: {
    lang: 'fra',
  },
  cashout: {
    enablePartial: true,
  },
  currencySymbol: {
    USD: '$',
    EUR: '€',
    CDF: 'FC',
  },
  cashoutMethods: [
    { type: 'printTicket' },
  ],
  betBuilder: {
    brandName: '',
  },
  registrationFormConfigs: {
    enabledInHeader: false,
    country: 'DR Congo',
    registrationFormSteps: [
      {
        name: 'personal_information',
        label: 'Personal',
        fields: [
          { name: 'firstName', enabled: true },
          { name: 'lastName', enabled: true },
          { name: 'birthDate', enabled: true },
          { name: 'country', enabled: true },
        ],
      },
      {
        name: 'contact_information',
        label: 'Contacts',
        fields: [
          { name: 'email', enabled: true },
          { name: 'phoneNumber', enabled: true },
          { name: 'street', enabled: true, className: 'contacts-section' },
          { name: 'city', enabled: true, className: 'contacts-section' },
          { name: 'zipCode', enabled: true, className: 'contacts-section' },
        ],
      },
      {
        name: 'credential_information',
        label: 'Credentials',
        fields: [
          { name: 'userName', enabled: true, className: 'credential-section' },
          { name: 'password', enabled: true },
          { name: 'confirmPassword', enabled: true },
        ],
      },
      {
        name: 'registrationTermsAndConditions_information',
        label: 'Final',
        fields: [
          { name: 'rull18', enabled: true },
          { name: 'termsAndConditions', enabled: true },
        ],
      },
    ],
    registrationUserName: 'userName',
  },
  settingsSection: {
    sections: ['adminAccess', 'oddsType', 'language'],
  },
  lastTicketButtons: [
    {
      name: 'Bet tickets',
      type: 'betTicket',
      hideOnRestrictMode: false,
    },
    {
      name: 'Cash-out',
      type: 'cashoutTicket',
      hideOnRestrictMode: false,
    },
    {
      name: 'Pay-out',
      type: 'payoutTicket',
      hideOnRestrictMode: false,
    },
  ],
  routes: [
    {
      url: 'worldcup',
      name: 'FIFA World Cup',
      enabled: true,
      disableInHeader: true,
    },
    {
      name: 'Betting',
      url: 'betting/prematch/all',
      type: 'sportsBook',
      enabled: true,
      nestedItems: [
        {
          url: 'betting/live/all',
          type: 'live',
          name: 'Live',
          enabled: true,
          icon: 'circle',
        },
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'Sports',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/virtuals',
          type: 'virtuals',
          name: 'Virtuals',
          enabled: true,
          icon: 'casino-categories-VirtualBetting',
          children: [
            {
              name: 'Games',
              url: 'betting/prematch/virtuals',
              icon: '',
            },
            {
              name: 'Results',
              url: 'betting/virtual-results',
              icon: '',
            },
          ],
        },
        {
          url: 'betting/prematch/betBuilder',
          type: 'betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
        {
          url: 'betting/racings',
          name: 'Racing',
          enabled: false,
          icon: 'racing-horse-grayhounds',
          children: [
            {
              name: 'Horses',
              url: 'betting/racings/horse-racing',
              icon: '',
            },
            {
              name: 'Greyhounds',
              url: 'betting/racings/greyhounds',
              icon: '',
            },
          ],
        },
        {
          url: 'betting/results',
          name: 'Results',
          type: 'results',
          enabled: true,
          icon: '',
        }
      ],
    },
    {
      name: 'Virtual Games',
      url: 'thirdPartyGame/400002',
      type: 'virtualGames',
      enabled: true,
      nestedItems: [
        {
          url: 'thirdPartyGame/400002',
          name: 'Golden Race',
          type: 'goldenRace',
          iframeFullscreen: false,
          enabled: true,
          icon: 'golden-race',
          gameId: '400002',
          gameWithSecondScreen: false,
          onlyInHeader: true,
        },
        {
          url: 'thirdPartyGame/156147',
          name: 'Pascal Gaming',
          type: 'pascalGaming',
          enabled: true,
          iframeFullscreen: false,
          gameId: '156147',
          icon: 'casino-categories-PGgames',
          gameWithSecondScreen: false,
          onlyInHeader: false,
        },
      ],
    },
    {
      name: 'Casino',
      url: 'casino',
      type: 'casino',
      enabled: true,
      nestedItems: [
        {
          name: 'Casino',
          type: 'casino',
          url: 'casino',
          enabled: true,
          icon: 'casino-7',
        },
        {
          name: 'Live Casino',
          type: 'liveCasino',
          url: 'liveCasino',
          enabled: true,
          icon: 'casino-categories-LotteryGames',
        },
      ],
    },
    {
      url: 'casino-category/406',
      name: 'Crash Games',
      enabled: true,
    },
    {
      url: 'tickets',
      name: 'Tickets',
      enabled: true,
    },
  ],
  defaultTerminalParams: { pid: 18773850, tid: 41803, token: 'GlrfLw==', currency: 'CDF' },
  betslip: {
    enableCounterOffer: false,
    enableExpressCounterOffer: true,
    enableBookingBet: true,
    bookingBetBalanceMaxLimit: 9999999,
    enableBankerBet: true,
    enableExpressBonus: true,
  },
  sportsbook: {
    enableBoostedOdds: true,
  },
};
